import React, { FC } from 'react';
import styled from 'styled-components';
import {
  CpBody03Placeholder,
  CpHeading03Primary,
} from 'components/atoms/customer-portal/typography';

const CpWidgetTitle = styled(CpHeading03Primary)``;
const CpWidgetDescription = styled(CpBody03Placeholder)`
  @media (max-width: 480px) {
    flex: 1 1 auto; /* Allow the item to grow and shrink */
    overflow: hidden; /* Hide overflow text */
    white-space: normal; /* Prevent text from wrapping */
    /* ellipsize after two lines */

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    line-clamp: 2;
    overflow: hidden;
  }
`;
const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-03);
`;

interface Props {
  title?: string;
  description?: string;
  className?: string;
}
const WidgetHeader: FC<Props> = ({
  title,
  description,
  className,
  children,
}) => (
  <HeaderWrapper className={className}>
    {children != null ? (
      children
    ) : (
      <>
        {title ? <CpWidgetTitle autoAdjustColor>{title}</CpWidgetTitle> : null}
        {description ? (
          <CpWidgetDescription autoAdjustColor>
            {description}
          </CpWidgetDescription>
        ) : null}
      </>
    )}
  </HeaderWrapper>
);
const StyledHeader = styled(WidgetHeader)``;

type CpWidgetHeader = typeof StyledHeader & {
  Title: typeof CpWidgetTitle;
  Description: typeof CpWidgetDescription;
};
const CpWidgetHeader: CpWidgetHeader = StyledHeader as any;

CpWidgetHeader.Title = CpWidgetTitle;
CpWidgetHeader.Description = CpWidgetDescription;

export { CpWidgetHeader };
